import { createReducer } from '../../lib/Utils'
import {
  GET_ALLOCATION_DETAILS_FULFILLED,
  GET_RETAILER_ALERTS_FULFILLED,
  MARK_ALERT_FULFILLED,
  MARK_ALL_ALERTS_AS_READ_FULFILLED,
  GET_RETAILER_ACCOUNT_FULFILLED,
} from './actions'

const initialState = {}

export default createReducer(initialState, {
  [GET_RETAILER_ACCOUNT_FULFILLED]: (state, action) => {
    const id = action.payload.response.id
    const currentRetailerAccount = state[id] || {}
    return {
      ...state,
      [id]: {
        ...currentRetailerAccount,
        retailerAccount: action.payload.response,
      },
    }
  },
  [GET_ALLOCATION_DETAILS_FULFILLED]: (state, action) => {
    const retailerAccount = {
      ...state[action.payload.id],
      allocationDetails: action.payload.response,
    }

    const newState = {
      ...state,
      [action.payload.id]: retailerAccount,
    }

    return newState
  },
  [GET_RETAILER_ALERTS_FULFILLED]: (state, action) => {
    const retailerAccount = {
      ...state[action.payload.id],
      alerts: action.payload.response,
    }

    const newState = {
      ...state,
      [action.payload.id]: retailerAccount,
    }

    return newState
  },
  [MARK_ALERT_FULFILLED]: (state, action) => {
    const retailerAccount = {
      ...state[action.payload.retailerAccountId],
    }
    let updatedAlert = retailerAccount.alerts.filter(
      (alert) => alert.id === action.payload.id,
    )[0]
    updatedAlert.status = action.payload.status

    // We lose alert.subjectables in this response.
    // To make sure that doesn't happen, we merge the
    // new alert/updated status with the old alert/subjectables
    const newState = {
      ...state,
      [action.payload.retailerAccountId]: {
        ...retailerAccount,
        alerts: [
          ...state[action.payload.retailerAccountId].alerts.filter(
            (alert) => alert.id !== action.payload.id,
          ),
          updatedAlert,
        ],
      },
    }
    return newState
  },
  [MARK_ALL_ALERTS_AS_READ_FULFILLED]: (state, action) => {
    const retailerAccount = {
      ...state[action.payload.id],
    }
    const readAlerts = retailerAccount.alerts.map((alert) => {
      return {
        ...alert,
        status: 'read',
      }
    })
    retailerAccount.alerts = readAlerts
    const newState = {
      ...state,
      [action.payload.id]: retailerAccount,
    }
    return newState
  },
})
